import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import {
  Checkbox,
  Button,
  Space,
} from 'antd';

import { Container } from './styles';

const ColumnSelect = (options, dataIndex, onFilter) => {
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
  };

  const handleCheckboxChange = (value, checked, setSelectedKeys) => {
    if (checked) {
      setSelectedKeys([value]);
    } else {
      setSelectedKeys([]);
    }
  };

  return {
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <Container>
        {options.map((option) => (
          <div key={option.value} style={{ marginBottom: 8 }}>
            <Checkbox
              checked={selectedKeys.includes(option.value)}
              onChange={(e) => handleCheckboxChange(option.value, e.target.checked, setSelectedKeys)}
            >
              {option.text}
            </Checkbox>
          </div>
        ))}
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Filtrar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Limpar
          </Button>
        </Space>
      </Container>
    ),
    onFilter: onFilter || ((value, record) => {
      const recordValue = record[dataIndex];
      return recordValue === value;
    }),
  };
};

export default ColumnSelect;
